<template>
	<div class="large-search">
		<div class="search-title">
			<span class="search-pro">{{searchpro[0]}}</span>
		</div>
		<div class="search-content">
			<div class="search-content-inner">
				<span class="search-what first">{{searchpro[1]}}</span>
				<div class="wrapper-search">
					<input type="text" class="search-input-text"/>
					<i class="bri-icon-xingtaiduICON_sousuo--"></i>
				</div>
				<span class="search-what">{{searchpro[2]}}</span>
				<div class="wrapper-search">
					<input type="text" class="search-input-text"/>
					<i class="bri-icon-xingtaiduICON_sousuo--"></i>
				</div>
			</div>
		</div>
	</div>
</template>

<script type="text/ecmascript-6">
export default {
	data() {
		return {
		}
	},
	computed: {
		searchpro() {
			return this.$t('searchpro')
		}
	}
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"

	.large-search
		width: 100%
		.search-title
			width: 100%
			background: $color-theme
			height: 30px
			.search-pro
				font-size: $font-web-small
				color: $color-text
				text-align: center
				display: block
				line-height: 30px
		.search-content
			width: 100%
			background: $color-text-g
			height: 140px
			.search-content-inner
				width: 80%
				margin: 0 auto
				padding-top: 8px
				.search-what
					font-size: $font-web-small
					color: $color-text
					display: block
					margin-top: 10px
				.wrapper-search
					width: 100%
					position: relative
					.search-input-text
						width: 100%
						background: $color-theme
						height: 20px
						border-radius: 2px
					.bri-icon-xingtaiduICON_sousuo--
						position: absolute
						top: 5px
						right: 5px
						color: $color-text
						font-size: $font-web-small-s
</style>



// WEBPACK FOOTER //
// src/common/large-search/large-search.vue